import type { Reducer } from 'redux';
import { Map } from 'immutable';

import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';
import { DashboardActions } from 'features/dashboard/redux/actions';
import {
  SET_SUMMARY_GRAPH_MODE,
  SET_SUMMARY_GRAPH_DATA,
  SET_SUMMARY_GRAPH_LOADING,
  SET_SUMMARY_GRAPH_START_DATE,
} from 'features/dashboard/redux/types';
import { LOGOUT_SUCCESS } from 'features/auth/redux/types';
import { RadialChartItem } from 'features/dashboard/ts/RadialChartItem';
import { getRangeStart } from 'features/dashboard/utils/getRangeStart';

export interface SummaryReducerGraphState {
  monthlyGraph: Map<number, RadialChartItem[]>;
  weeklyGraph: Map<number, RadialChartItem[]>;
  dailyGraph: Map<number, RadialChartItem[]>;
  isLoading: boolean;
  mode: ChartViewMode;
  rangeStart: Date;
}

const INITIAL_STATE: SummaryReducerGraphState = {
  monthlyGraph: Map<number, RadialChartItem[]>(),
  weeklyGraph: Map<number, RadialChartItem[]>(),
  dailyGraph: Map<number, RadialChartItem[]>(),
  mode: ChartViewMode.Monthly,
  rangeStart: getRangeStart(new Date(), ChartViewMode.Monthly, true),
  isLoading: false,
};

export const summaryReducer: Reducer<SummaryReducerGraphState, DashboardActions> = (
  state = INITIAL_STATE,
  action
): SummaryReducerGraphState => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    case SET_SUMMARY_GRAPH_MODE:
      return {
        ...state,
        mode: action.payload,
        rangeStart: getRangeStart(state.rangeStart, action.payload, true),
      };
    case SET_SUMMARY_GRAPH_START_DATE:
      return {
        ...state,

        rangeStart: getRangeStart(action.payload, state.mode, true),
      };
    case SET_SUMMARY_GRAPH_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_SUMMARY_GRAPH_DATA:
      const newState = { ...state };

      const cacheKey = state.rangeStart.getTime();

      switch (state.mode) {
        case ChartViewMode.Daily:
          newState.dailyGraph = newState.dailyGraph.set(cacheKey, action.payload);
          break;
        case ChartViewMode.Weekly:
          newState.weeklyGraph = newState.weeklyGraph.set(cacheKey, action.payload);
          break;
        case ChartViewMode.Monthly:
          newState.monthlyGraph = newState.monthlyGraph.set(cacheKey, action.payload);
          break;
      }

      return newState;

    default:
      return state;
  }
};
